import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  header: {
    id: 'learn.gatedLock.header',
    defaultMessage: 'This content is locked.',
  },
  description: {
    id: 'learn.gatedLock.description',
    defaultMessage: 'To access this content you have to get at least {number}% grade for the course.',
  },
});

export default messages;
